import { useEffect, useState } from "react";
import { useSelectedDate } from "../context/SelectedDateContext";
import { useNavigate, useSearchParams } from "react-router-dom";
import Logo from "../components/Logo";
import BackButton from "../components/BackButton";
import { ReservationService } from "../services/ReservationService";

export default function AvailableReservations() {
  const { selectedDate, setSelectedDate, setSelectedSchool, availableSchools, setAvailableSchools } = useSelectedDate();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState(true);

  // Get date from URL if not in context
  const dateFromUrl = searchParams.get('date');
  const effectiveDate = selectedDate || (dateFromUrl ? new Date(dateFromUrl + 'T00:00:00') : null);

  useEffect(() => {
    async function loadAvailability() {
      if (dateFromUrl && !selectedDate) {
        // Set the date in context
        const date = new Date(dateFromUrl + 'T00:00:00');
        setSelectedDate(date);

        // Fetch schools for this date
        try {
          const service = new ReservationService();
          const schools = await service.getAvailableSchoolsForDate(dateFromUrl);
          setAvailableSchools(schools || []);
        } catch (error) {
          console.error("Error loading schools:", error);
          setAvailableSchools([]);
        }
      }
      setLoading(false);
    }
    loadAvailability();
  }, [dateFromUrl, selectedDate, setSelectedDate, setAvailableSchools]);

  const handleSchoolClick = (school) => {
    setSelectedSchool(school);
    navigate(`/confirm-reservation?date=${effectiveDate.toISOString().split('T')[0]}&schoolId=${school._id}`);
  };

  if (loading) {
    return (
      <div className="text-center p-5">
        <h2>Carregando...</h2>
      </div>
    );
  }

  if (!effectiveDate) {
    return (
      <div>
        <div
          className="d-flex align-items-center justify-content-center position-relative"
          style={{ height: "125px" }}
        >
          <BackButton />
          <Logo center className="mb-4" size="125px" />
        </div>
        <div className="text-center">É necessário selecionar uma data.</div>
      </div>
    );
  }

  if (availableSchools.length === 0) {
    return (
      <>
        <div
          className="d-flex align-items-center justify-content-center position-relative"
          style={{ height: "125px" }}
        >
          <BackButton />
          <Logo center className="mb-4" size="125px" />
        </div>
        <div className="text-center">
          Nenhuma escola disponível para essa data.
        </div>
      </>
    );
  }

  return (
    <div className="container p-5">
      <div
        className="d-flex align-items-center justify-content-center position-relative"
        style={{ height: "125px" }}
      >
        <BackButton />
        <Logo center className="mb-4" size="125px" />
      </div>

      <div className="text-center">
        <h2 className="my-5">Selecione a unidade desejada</h2>
      </div>

      {/* <div className="text-center my-5">
        <h2 className="fw-bold">MAIS PRÓXIMAS</h2>
      </div> */}

      {availableSchools.map((school, index) => (
        <div
          className="row"
          key={index}
          onClick={() => handleSchoolClick(school)}
          style={{ cursor: "pointer" }}
        >
          <div className="col-12 mb-4 text-center">
            <div className="col-12">
              <div className="px-3">
                <div className="row align-items-center justify-content-center border border-secondary border-2 rounded-5 pb-3 pt-3">
                  <div
                    className="col-12 text-center"
                    style={{ width: "fit-content" }}
                  >
                    {school.name}
                    <br />
                    {school.address.neighborhood}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
